import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  description,
  onCancel,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    PaperProps={{
      sx: {
        borderRadius: 2,
        minWidth: 420,
        p: 0,
        overflow: "visible",
      },
    }}
  >
    <DialogTitle
      sx={{
        bgcolor: "#F7F7F7", // Match the white background in the image
        fontWeight: 500,
        fontSize: 20, // Slightly smaller font size to match the image
        py: "22px",
        pl: "26px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: "#000",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
      }}
    >
      {title}
      <IconButton onClick={onCancel} sx={{ ml: 2 }}>
        <CloseIcon sx={{ fontSize: 24 }} /> {/* Adjust icon size */}
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ px: 2, fontSize: 16, my: 4 }}>
      {/* Adjust font size and padding */}
      {description}
    </DialogContent>
    <Box sx={{ borderTop: "1px solid #ddd" }} /> {/* Lighter divider color */}
    <DialogActions sx={{ justifyContent: "flex-end", px: 2, py: 2 }}>
      <Button
        onClick={onCancel}
        variant="outlined"
        sx={{
          borderRadius: 2,
          minWidth: 100, // Slightly smaller width
          fontSize: 16,
          fontWeight: 500,
          mr: 1, // Space between buttons
          bgcolor: "transparent", // Transparent background
          color: "#000", // Black text
          borderColor: "#000", // Black border
          ":hover": { bgcolor: "#f0f0f0", borderColor: "#000" }, // Light hover effect
        }}
      >
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        sx={{
          borderRadius: 2,
          minWidth: 100, // Slightly smaller width
          fontSize: 16,
          fontWeight: 500,
          bgcolor: "#000", // Black background
          color: "#fff", // White text
          boxShadow: "none",
          ":hover": { bgcolor: "#333" }, // Darker hover effect
        }}
      >
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
